// extracted by mini-css-extract-plugin
export default {"msg":"HelpMessageWidget-module__[local]___wDjWk"};